import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";
import { getLang, langOverridden, setLang } from "../lib/i18n";

const AuthContext = createContext(null);
const USER_KEY = "logidem-user";

const remember = (u) => {
  if (u) localStorage.setItem(USER_KEY, JSON.stringify(u));
  else localStorage.removeItem(USER_KEY);
};

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    api.get("/auth/me").then((r) => {
      if (r.data.lang && r.data.lang !== getLang() && !langOverridden()) return setLang(r.data.lang);
      setUser(r.data);
      remember(r.data);
    }).catch((e) => {
      const cached = !e.response && localStorage.getItem(USER_KEY);
      setUser(cached ? JSON.parse(cached) : false);
    });
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    await api.put("/auth/lang", { lang: getLang() }).catch(() => {});
    setUser(data.user);
    remember(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    await api.put("/auth/lang", { lang: getLang() }).catch(() => {});
    setUser(data.user);
    remember(data.user);
    return data.user;
  };

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    remember(null);
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, setUser, login, register, logout }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
